export const hcExtra = {
  reservas: {
    buscar: "Buscar",
    limpiar: "Limpar",
    todas: "Todos",
  },
  nav: {
    volver: "Voltar",
  },
  listingDetail: {
    badgeNew: "Novo",
  },
  ofertas: {
    precio: "Preço",
  },
  payService: {
    sendRequest: "Enviar solicitação",
  },
  accountCfg: {
    accountEmail: "E-mail da conta",
  },
};
